<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Edit Data</p>
                <argon-button color="success" size="sm" class="ms-auto" @click="save()"
                  >Simpan</argon-button
                >
                <argon-button color="danger" size="sm" class="mx-3" @click="back()"
                  >Kembali</argon-button
                >
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Wilayah</label
                      >
                      <VueMultiselect
                        v-model="datas.WILAYAH"
                        :options="data_wilayah"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="wilayah"
                        track-by="wilayah"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Sektor</label
                      >
                      <VueMultiselect
                        v-model="datas.SEKTOR"
                        :options="filtered_sektor"
                        :multiple="false"
                        :close-on-select="true"
                        :placeholder="datas.WILAYAH && datas.WILAYAH.id ? 'Pilih' : 'Pilih Wilayah terlebih dahulu'"
                        :disabled="!datas.WILAYAH || !datas.WILAYAH.id"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nomor KK</label
                      >
                      <argon-input type="text" v-model:value="datas.ID_KELUARGA" />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Keluarga</label
                      >
                      <argon-input type="text" v-model:value="datas.NAMA_KELUARGA" />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Status</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS"
                        :options="data_status"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Status Aktif</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_AKTIF"
                        :options="[{'id': '1', 'nama':'Aktif'},{'id': '0', 'nama':'Tidak Aktif'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Pilih"
                        label="nama"
                        track-by="nama"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kota</label
                      >
                      <argon-input type="text" v-model:value="datas.KOTA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Provinsi</label
                      >
                      <argon-input type="text" v-model:value="datas.PROPINSI" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Negara</label
                      >
                      <argon-input type="text" v-model:value="datas.NEGARA" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kodepos</label
                      >
                      <argon-input type="text" v-model:value="datas.KODEPOS" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Telp / HP</label
                      >
                      <argon-input type="text" v-model:value="datas.TELP" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Nikah</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_NIKAH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Nikah</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_NIKAH" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Capil</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_CAPIL" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Capil</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_CAPIL" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Keterangan Khusus</label
                      >
                      <argon-input type="text" v-model:value="datas.KET_KHUSUS" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Masuk</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_MASUK" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Keluar</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_KELUAR" />
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <auth-check></auth-check>
  </main>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<script>
/* eslint-disable */
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import VueMultiselect from 'vue-multiselect'
import AuthCheck from '@/components/authCheck.vue'

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      datas: {
        ID: 0,
        ID_KELUARGA: 0,
        SEKTOR: '',
        WILAYAH: '',
        STATUS_KELUARGA: '',
        NAMA_KELUARGA: '',
        STATUS: '',
        ALAMAT: '',
        KOTA: '',
        PROPINSI: '',
        KODEPOS: '',
        NEGARA: '',
        TELP: '',
        KET_KHUSUS: '',
        TGL_NIKAH: '',
        TGL_CAPIL: '',
        TEMPAT_CAPIL: '',
        TEMPAT_NIKAH: '',
      },
      data_wilayah: [],
      data_sektor: [],
      data_gaji: [],
      data_minat: [],
      data_goldar: [],
      data_hobby: [],
      data_jabatan: [],
      data_kewarganegaraan: [],
      data_klasifikasi: [],
      data_negara: [],
      data_pekerjaan: [],
      data_pelayanan: [],
      data_pendidikan: [],
      data_perkawinan: [],
      data_profesi: [],
      data_status: [],
      data_statusKeluarga: [],
      
    };
  },
  components: { 
    ArgonInput, 
    VueMultiselect,
    ArgonButton, 
    AuthCheck, 
  },
  computed: {
    filtered_sektor() {
      if (!this.datas.WILAYAH || !this.datas.WILAYAH.id) return [];
      return this.data_sektor.filter(s => s.id_wilayah === this.datas.WILAYAH.id);
    }
  },
  watch: {
    'datas.WILAYAH'(newVal, oldVal) {
      if (oldVal && newVal && oldVal.id !== newVal.id) {
        this.datas.SEKTOR = null;
      }
    },
    PEKERJAAN(newVal){
      console.log(newVal)
    },
    MINAT_PELAYANAN2(newVal){
      var pelayantemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        pelayantemp += element.nama + ", "
      });
      this.MINAT_PELAYANAN = pelayantemp.slice(0, -2)
      console.log(this.MINAT_PELAYANAN)
    },
    MINAT2(newVal){
      var minattemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        minattemp += element.nama + ", "
      });
      this.MINAT = minattemp.slice(0, -2)
      console.log(this.MINAT)
    },
    HOBBY2(newVal){
      console.log(newVal)

      var hobbytemp = "";
      JSON.parse(JSON.stringify(newVal)).forEach(element => {
        hobbytemp += element.nama + ", "
      });
      this.HOBBY = hobbytemp.slice(0, -2)
      console.log(this.HOBBY)
    }
  },
  methods: {
    back(){
      this.$router.back();
    },
    save(){
      this.axios.put(process.env.VUE_APP_API_URL + "keluarga/update", {
        "ID": this.datas.ID,
        "ID_KELUARGA" : this.datas.ID_KELUARGA,
        "STATUS_KELUARGA" : this.datas.STATUS_KELUARGA,
        "NAMA_KELUARGA" : this.datas.NAMA_KELUARGA,
        "ALAMAT" : this.datas.ALAMAT,
        "KOTA" : this.datas.KOTA,
        "PROPINSI" : this.datas.PROPINSI,
        "KODEPOS" : this.datas.KODEPOS,
        "NEGARA" : this.datas.NEGARA,
        "TELP" : this.datas.TELP,
        "KET_KHUSUS" : this.datas.KET_KHUSUS,
        "TGL_NIKAH" : this.datas.TGL_NIKAH,
        "TGL_CAPIL" : this.datas.TGL_CAPIL,
        "TEMPAT_CAPIL" : this.datas.TEMPAT_CAPIL,
        "TEMPAT_NIKAH" : this.datas.TEMPAT_NIKAH,
        "SEKTOR": JSON.parse(JSON.stringify(this.datas.SEKTOR)).id,
        "STATUS": JSON.parse(JSON.stringify(this.datas.STATUS)).id,
        "STATUS_AKTIF": JSON.parse(JSON.stringify(this.datas.STATUS_AKTIF)).id,
        "WILAYAH": JSON.parse(JSON.stringify(this.datas.WILAYAH)).id,
      }, {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then(() => {
        this.$toast.open({
            message: 'Data Tersimpan!',
            type: 'success',
        });
        this.$router.push({
          name: "Data Keluarga",
        })
      }).catch((ex) => {
        console.log(ex)
        this.$toast.open({
            message: 'Terjadi Kesalahan, cek Console!',
            type: 'error',
        });
      });
    }
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
      "Authorization": "Bearer " + localStorage.getItem("token")
    }}).then((resp) => {
      this.data_wilayah = JSON.parse(JSON.stringify(resp.data)).wilayah
      this.data_sektor = JSON.parse(JSON.stringify(resp.data)).sektor
      this.data_gaji = JSON.parse(JSON.stringify(resp.data)).gaji
      this.data_goldar = JSON.parse(JSON.stringify(resp.data)).goldar
      this.data_hobby = JSON.parse(JSON.stringify(resp.data)).hobby
      this.data_jabatan = JSON.parse(JSON.stringify(resp.data)).jabatan
      this.data_kewarganegaraan = JSON.parse(JSON.stringify(resp.data)).kewarganegaraan
      this.data_klasifikasi = JSON.parse(JSON.stringify(resp.data)).klasifikasi
      this.data_negara = JSON.parse(JSON.stringify(resp.data)).negara
      this.data_pekerjaan = JSON.parse(JSON.stringify(resp.data)).pekerjaan
      this.data_pelayanan = JSON.parse(JSON.stringify(resp.data)).pelayanan
      this.data_pendidikan = JSON.parse(JSON.stringify(resp.data)).pendidikan
      this.data_perkawinan = JSON.parse(JSON.stringify(resp.data)).perkawinan
      this.data_profesi = JSON.parse(JSON.stringify(resp.data)).profesi
      this.data_status = JSON.parse(JSON.stringify(resp.data)).status
      this.data_statusKeluarga = JSON.parse(JSON.stringify(resp.data)).statusKeluarga
      this.data_minat = JSON.parse(JSON.stringify(resp.data)).minat
    });
    this.axios.get(process.env.VUE_APP_API_URL + "keluarga/"+this.$route.params.id, {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then((resp) => {
        this.datas = JSON.parse(JSON.stringify(resp.data.data))
        if(this.datas.STATUS_AKTIF == "1"){
          this.datas.STATUS_AKTIF = {'id': '1', 'nama':'Aktif'}
        } else {
          this.datas.STATUS_AKTIF = {'id': '0', 'nama':'Tidak Aktif'}
        }
      })
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
